import _findIndex from 'lodash/findIndex';
import FeatureFlags from '../../../../util/featureFlags';

const showSeatingChart = FeatureFlags.get('seatingChartLanding');

// WEBSITE NAV - POST AUTH
const manageWebsite = {
  navUrl: '/wedding/manage/website/manage',
  navText: 'Manage Website',
};

const editWebsite = {
  navUrl: '/wedding/manage/website/pages/home',
  navText: 'Edit Pages',
};

const viewDesigns = {
  navUrl: '/wedding/manage/website/designs',
  navText: 'View Designs',
};

// GUEST LIST NAV - POST AUTH
const guestDirectory = {
  navUrl: '/wedding/manage/guests/all',
  navText: 'All Guests',
};

const buildGuestLists = {
  navUrl: '/wedding/manage/guests/build',
  navText: 'Build Guest Lists',
};

const addressEnvelopes = {
  navUrl: '/wedding/manage/guests/envelopes',
  navText: 'Address Envelopes',
};

const trackRSVP = {
  navUrl: '/wedding/manage/guests/rsvps/overview',
  navText: 'Track RSVPs',
};

const requestRsvpAccess = {
  navUrl: '/wedding/manage/guests/rsvp-notifications',
  receivesNotifications: true,
  navText: 'View RSVP Requests'
};


// PREAUTH NAV - PRE AUTH
const preauthChecklist = {
  navUrl: '/wedding-planning/checklist',
  navText: 'Wedding Checklist',
};

const preauthGuestList = {
  navUrl: '/wedding-planning/guests',
  navText: 'Guest List',
};

const planningDashboard = {
  navUrl: '/wedding/manage',
  navText: 'Planning Dashboard'
};

const guestList = {
  navUrl: '/wedding/manage/guests',
  navText: 'Guest List',
  receivesNotifications: true
};

const events = {
  navUrl: '/wedding/manage/events',
  navText: 'Events'
};

const seatingChart = {
  navUrl: '/wedding/manage/seating',
  navText: 'Seating Chart'
};

const checklist = {
  navUrl: '/wedding/manage/wedding-checklist',
  navText: 'Wedding Checklist'
};

// INSPIRATION

const realWeddings = {
  navUrl: '/inspiration',
  navText: 'Real Wedding Inspiration',
  notReactLink: true,
};

const austin = {
  navUrl: '/inspiration/real-weddings/austin-tx',
  navText: 'Austin, TX',
  notReactLink: true,
};

const charlottesville = {
  navUrl: '/inspiration/real-weddings/charlottesville-va',
  navText: 'Charlottesville, VA',
  notReactLink: true,
};

const charleston = {
  navUrl: '/inspiration/real-weddings/charleston-sc',
  navText: 'Charleston, SC',
  notReactLink: true,
};

const chicago = {
  navUrl: '/inspiration/real-weddings/chicago-il',
  navText: 'Chicago, IL',
  notReactLink: true,
};

const denver = {
  navUrl: '/inspiration/real-weddings/denver-co',
  navText: 'Denver, CO',
  notReactLink: true,
};

const miami = {
  navUrl: '/inspiration/real-weddings/miami-fl',
  navText: 'Miami, FL',
  notReactLink: true,
};

const napa = {
  navUrl: '/inspiration/real-weddings/napa-ca',
  navText: 'Napa, CA',
  notReactLink: true,
};

const nashville = {
  navUrl: '/inspiration/real-weddings/nashville-tn',
  navText: 'Nashville, TN',
  notReactLink: true,
};

const newOrleans = {
  navUrl: '/inspiration/real-weddings/new-orleans-la',
  navText: 'New Orleans, LA',
  notReactLink: true,
};

const newYork = {
  navUrl: '/inspiration/real-weddings/new-york-ny',
  navText: 'New York, NY',
  notReactLink: true,
};

const richmond = {
  navUrl: '/inspiration/real-weddings/richmond-va',
  navText: 'Richmond, VA',
  notReactLink: true,
};

const sanFrancisco = {
  navUrl: '/inspiration/real-weddings/san-francisco-ca',
  navText: 'San Francisco, CA',
  notReactLink: true,
};

const seattle = {
  navUrl: '/inspiration/real-weddings/seattle-wa',
  navText: 'Seattle, WA',
  notReactLink: true,
};

const tampa = {
  navUrl: '/inspiration/real-weddings/tampa-fl',
  navText: 'Tampa, FL',
  notReactLink: true,
};

const viewAllWeddings = {
  navUrl: '/inspiration/real-weddings',
  navText: 'View All Weddings',
  notReactLink: true
};

const marketplaceWeddingVendors = {
  navUrl: '/inspire/search',
  navText: 'Wedding Vendors',
  notReactLink: true,
};

const marketplaceWeddingVenues = {
  navUrl: '/inspire/search/wedding-venues',
  navText: 'Wedding Venues',
  notReactLink: true,
};

const marketplacWeddingPhotographers = {
  navUrl: '/inspire/search/wedding-photographers',
  navText: 'Photographers',
  notReactLink: true,
};

const marketplaceWeddingVideographers = {
  navUrl: '/inspire/search/wedding-videographers',
  navText: 'Videographers',
  notReactLink: true,
};

const marketplacWeddingCaterers = {
  navUrl: '/inspire/search/wedding-caterers',
  navText: 'Caterers',
  notReactLink: true,
};

const marketplacWeddingFlorists = {
  navUrl: '/inspire/search/wedding-florists',
  navText: 'Florists',
  notReactLink: true,
};

// INVITES + PAPER
const saveTheDate = {
  navUrl: '/wedding-planning/save-the-date/shop',
  navText: 'Save The Dates'
};

const changeTheDate = {
  navUrl: '/wedding-planning/change-the-date/shop',
  navText: 'Change The Dates',
  newTag: true,
};

const invitations = {
  navUrl: '/wedding-planning/invitations/shop',
  navText: 'Invitations'
};

const enclosureCards = {
  navUrl: '/wedding-planning/enclosures/shop',
  navText: 'Enclosure Cards'
};

const menus = {
  navUrl: '/wedding-planning/menus/shop',
  navText: 'Menus'
};

const programs = {
  navUrl: '/wedding-planning/programs/shop',
  navText: 'Programs'
};

const thankYouCards = {
  navUrl: '/wedding-planning/thank-you-cards/shop',
  navText: 'Thank You Cards'
};

const holidayCards = {
  navUrl: '/wedding-planning/holiday-cards/shop',
  navText: 'Holiday Cards',
};

const ordersDrafts = {
  navUrl: '/wedding-planning/projects',
  navText: 'Your Orders + Drafts',
  showFn: userContext => userContext.has_invitation_account
};

const placeCards = {
  navUrl: '/wedding-planning/place-cards/shop',
  navText: 'Place Cards'
};

// EXPERT ADVICE
const expertAdvice = {
  navUrl: '/expert-advice',
  navText: 'Expert Advice',
  notReactLink: true
};

export const weddingWebsiteNavItems = [manageWebsite, editWebsite, viewDesigns];
export const guestListNavItems = [guestDirectory, buildGuestLists, addressEnvelopes, trackRSVP, requestRsvpAccess];
export const realWeddingsNavItems = [austin, charlottesville, charleston, chicago, denver, miami, napa, nashville, newOrleans, newYork, richmond, sanFrancisco, seattle, tampa, viewAllWeddings];
export const marketplaceVendorNavItems = [
  marketplaceWeddingVenues,
  marketplacWeddingPhotographers,
  marketplaceWeddingVideographers,
  marketplacWeddingCaterers,
  marketplacWeddingFlorists,
];

const weddingVendorsNavItems = [marketplaceWeddingVendors, marketplaceVendorNavItems];
const invitesPaperNavItems = FeatureFlags.get('changeTheDateCardType') ? [saveTheDate, changeTheDate, invitations, enclosureCards, menus, programs, thankYouCards, holidayCards] : [saveTheDate, invitations, enclosureCards, menus, programs, thankYouCards, holidayCards];
const invitesPaperNavItemsMobile = FeatureFlags.get('changeTheDateCardType') ? [saveTheDate, changeTheDate, invitations, enclosureCards, menus, programs, thankYouCards, holidayCards] : [saveTheDate, invitations, enclosureCards, menus, programs, thankYouCards, holidayCards];
if (FeatureFlags.get('invitesPlacementCards')) {
  // Get index of thank you cards to insert right before it. This is temporary just to assure
  // proper position before thank you cards
  const desktopIndex = _findIndex(invitesPaperNavItems, item => item.navText === 'Thank You Cards');
  const mobileIndex = _findIndex(invitesPaperNavItemsMobile, item => item.navText === 'Thank You Cards');
  invitesPaperNavItems.splice(desktopIndex, 0, placeCards);
  invitesPaperNavItemsMobile.splice(mobileIndex, 0, placeCards);
}
invitesPaperNavItems.push(ordersDrafts);

export { invitesPaperNavItems, invitesPaperNavItemsMobile };

export const preauthNavItems = [
  preauthChecklist,
  preauthGuestList,
  [realWeddings, realWeddingsNavItems],
  weddingVendorsNavItems,
  expertAdvice
];

export const manageNavItems = (showSeatingChart)
  ?
  [
    planningDashboard,
    [guestList, guestListNavItems],
    events,
    seatingChart,
    checklist,
    [realWeddings, realWeddingsNavItems],
    weddingVendorsNavItems,
    expertAdvice
  ]
  :
  [
    planningDashboard,
    [guestList, guestListNavItems],
    events,
    checklist,
    [realWeddings, realWeddingsNavItems],
    weddingVendorsNavItems,
    expertAdvice
  ];



// WEBPACK FOOTER //
// ./src/components/common/header/SecondaryNav/secondaryNavData.js